import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import NavBreadcrum from "components/NavBreadcrum";
import ButtonsActions from "../utils/buttonsActions";
import BoxFilter from "./BoxFilters";
import TableNotifications from "./TableNotifications";
import Message from "./Message";
import axiApi from "ApiCaller";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import Swal from "sweetalert2";
import navs from "./navs";
import FilterModel from "components/FilterModel";
import TopBarActions from "./TopBarActions";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import { PagerModel } from "components/paginator/PaginationModel";
import LoaderSpinner from "context/LoaderSpinner";
import ItemsModel from "core/itemsModel";
import { MessageModel } from "../../site-apps/notifications/MessageModel";

const ViewTrash = () => {
    const { t } = useTranslation("routes");
    const { t: _Tf } = useTranslation("forms");
    const bread = [{ name: t("labels.trash"), current: true }];
    const title = t("labels.trash");
    const items = useRef(new ItemsModel());
    const [item, setItem] = useState({ ...MessageModel });
    const [isLoading, setIsLoading] = useState(false);
    const [itemsShown, setItemsShown] = useState([]);
    const [showPrev, setShowPrev] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const pagerModelRef = useRef(new PagerModel());
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    document.title = title;

    const [isSelected, setIsSelected] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);

    const filters = useRef(new FilterModel());

    useEffect(() => {
        const buttons = { ...buttonsTB };
        buttons.title = title;
        buttons.trash.active = true;
        buttons.trash.onClick = onClickEmptyTrash;
        buttons.trash.disabled = false;
        buttons.trash.icon = "fa-trash-arrow-up";
        buttons.topBack.active = true;
        buttons.topBack.onClick = () => onClickRestore();
        buttons.topBack.disabled = true;
        buttons.filter.active = true;
        buttons.filter.onClick = onClickFilter;
        buttons.filter.disabled = false;
        setButtonsTB(buttons);
        pagerModelRef.current.handleCallApi = () => fetchTrashNotifications();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = MessageModel;
        fetchGetTrashNotifications();
        subscribeEvent("messageRead", onMessageRead);
        return () => {
            unsubscribeEvent("messageRead", onMessageRead);
        };
    }, []);

    useEffect(() => {
        setButtonsTB((prev) => ({
            ...prev,
        }));
    }, [items.current.chosen]);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchTrashNotifications();
    };

    const fetchGetTrashNotifications = async () => {
        setIsLoading(true);
        axiApi
            .get(`/api/notify/get/trash/`)
            .then((resp) => {
                if (resp.data.items) {
                    console.log("resp.data.items", resp.data.items);
                    items.current.all = [...resp.data.items];
                    items.current.showed = [...resp.data.items];
                    pagerModelRef.current.active = resp.data.items.length > 0;
                    pagerModelRef.current.paging.setPager(resp.data);
                    setItemsShown([...resp.data.items]);
                    setSelectedItemId(null);
                    setIsSelected(false);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchTrashNotifications = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/notify/get/trash/", filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            });
            if (resp.data.items) {
                items.current.all = resp.data.items;
                items.current.showed = resp.data.items;
                pagerModelRef.current.active = resp.data.items.length > 0;
                pagerModelRef.current.paging.setPager(resp.data);
                setItemsShown([...resp.data.items]);
                setSelectedItemId(null);
                setIsSelected(false);
                setCheckAll(false);
            }
        } catch (error) {
            console.error("Error al obtener notificaciones de papelera:", error);
        } finally {
            setIsLoading(false);
        }
    };

    function onClickMessage(item) {
        setItem(item)
        setIsSelected(true);
        setSelectedItemId(item.id);
    }

    function onClickFilter() {
        let buttons = { ...buttonsTB };
        buttons.title = title;
        buttons.filter.click = !buttonsTB.filter.click;
        buttons.filter.active = true;

        if (buttons.trash) {
            buttons.trash.active = true;
            buttons.trash.disabled = false;
        }
        setButtonsTB(buttons);
    }

    function onClickRestore() {
        if (items.current.chosen.length > 0) {
            Swal.fire({
                title: _Tf("labels.warning"),
                text: _Tf("delete.restore_warning"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: _Tf("labels.accept"),
                cancelButtonText: _Tf("labels.cancel"),
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    axiApi
                        .post(`/api/notify/restore/`, { id: items.current.chosen.at(-1) })
                        .then((resp) => {
                            fetchTrashNotifications();
                            setSelectedItemId(null);
                            setIsSelected(false);
                            items.current.chosen = [];
                            setButtonsTB((prev) => ({
                                ...prev,
                                topBack: {
                                    ...prev.topBack,
                                    disabled: true,
                                },
                            }));
                        })
                        .catch((error) => {
                            console.error("onClickRestore -> error", error);
                        });
                }
            });
        }
    }

    function onClickEmptyTrash() {
        Swal.fire({
            title: _Tf("labels.warning"),
            text: _Tf("delete.empty_trash_warning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: _Tf("labels.accept"),
            cancelButtonText: _Tf("labels.cancel"),
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiApi.get(`/api/notify/empty/trash/`).then((resp) => {
                    if (resp.status) {
                        fetchTrashNotifications();
                        setSelectedItemId(null);
                        setIsSelected(false);
                    }
                });
            }
        });
    }

    const onMessageRead = (event) => {
        let ids = [];
        if (event.detail) {
            if (event.detail.id) ids = [event.detail.id];
            else if (Array.isArray(event.detail.ids)) ids = event.detail.ids;
        }
        items.current.showed = items.current.showed.map((item) => (ids.includes(item.id) ? { ...item, read: true } : item));
    };


    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} title={title} />
            <BoxFilter show={buttonsTB.filter.click} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <LoaderSpinner isLoading={isLoading}>
                <div className="row" style={buttonsTB.filter.click ? { marginTop: "20px" } : {}}>
                    <div className="col-md-4 col-12" style={{ overflowY: "auto", height: "calc(100vh - 130px)" }}>
                        <TableNotifications
                            itemsShown={itemsShown}
                            onClickRow={onClickMessage}
                            isSelected={isSelected}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            items={items}
                        />
                    </div>
                    <div className="col-md-8 col-12 prev-item">
                        <Message item={item} />
                    </div>
                    <label className={itemsShown.length === 0 ? "" : "d-none"}>{_Tf("delete.empty_trash_message")}</label>
                </div>
            </LoaderSpinner>
        </>
    );
};

export default ViewTrash;